<template>
  <div class="app-container">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="listQuery"
            ref="listQuery"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Input v-model="listQuery.key"
                 clearable
                 placeholder="请输入关键字" />
        </FormItem>
        <FormItem>
          <Select v-model="listQuery.ti_type"
                  filterable
                  clearable
                  placeholder="请选择题型">
            <Option v-for="(item,index) in ti_type_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="handleFilter('listQuery')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="handleCreate()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
        <FormItem>
          <Button @click="handleImport()"
                  type="success"
                  icon="el-icon-plus"
                  class="f-l">导入</Button>
        </FormItem>
        <FormItem>
          <Button @click="downloadTpl"
                  type="warning"
                  icon="el-icon-download">
            下载模版
          </Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="column"
           :data="tableData"
           :loading="listLoading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="listQuery.total"
              :current="listQuery.page"
              :page-size="listQuery.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer title="题库"
            v-model="showDrawer"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <div class="custom-content">
        <Card class="box-card"
              style="margin-left: 20px;">
          <Form ref="ruleForm"
                :model="danwei"
                :rules="rules">
            <FormItem label="题型"
                      prop="ti_type">
              <Select v-model="danwei.ti_type"
                      filterable
                      clearable
                      placeholder="请选择题型">
                <Option v-for="(item,index) in ti_type_list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" />
              </Select>
            </FormItem>
            <FormItem label="题目"
                      prop="question">
              <Input v-model="danwei.question"
                     type="textarea" />
            </FormItem>
            <FormItem label="是否正确"
                      prop="is_right"
                      v-if="danwei.ti_type==3">
              <Select v-model="danwei.is_right"
                      style="width: 500px">
                <Option :value="1"
                        label="正确">正确</Option>
                <Option :value="0"
                        label="错误">错误</Option>
              </Select>
            </FormItem>
            <FormItem label="排序"
                      prop="sort">
              <Input-number style="width: 100px"
                            v-model="danwei.sort"
                            controls-position="right"
                            :min="0"></Input-number>
            </FormItem>
            <FormItem label="知识点"
                      prop="point">
              <Input v-model="danwei.point"
                     type="textarea" />
            </FormItem>
            <FormItem label="原文"
                      prop="origin">
              <Input v-model="danwei.origin"
                     type="textarea" />
            </FormItem>
          </Form>
          <div>
            <Button type="primary"
                    @click="addOption">新增选项</Button>
          </div>
        </Card>
        <div v-for="(option, index) in danwei.options"
             :key="index"
             style="margin-top: 10px"
             v-show="danwei.ti_type!=3">
          <Icon type="md-remove-circle"
                style="color: red;font-size: 20px;padding: 0 10px;margin-right: 10px;cursor: pointer;"
                @click="delBtnFun(index)" />
          <Input style="width: 500px;"
                 v-model="option.content"
                 placeholder="请输入选项内容"
                 type="textarea"></Input>
          <RadioGroup v-model="option.is_right">
            <Radio :label="1">正确</Radio>
            <Radio :label="0">错误</Radio>
          </RadioGroup>
        </div>
        <Checkbox v-model="continue_status"
                  v-if="continue_show">连续添加</Checkbox>
        <div class="demo-drawer-footer">
          <Button type="primary"
                  @click="tijiao('ruleForm')">提交</Button>
        </div>
      </div>
    </Drawer>
    <Modal title="导入文件"
           v-model="showImportModalStatus">
      <Form v-model="leadIn">
        <FormItem label="文件">
          <uploadFile ref="uploadFile"
                      tipInfo="文件支持excel格式"
                      v-model="leadIn.file_path"
                      :defaultList="fileList"></uploadFile>
        </FormItem>
      </Form>
      <div slot="footer"
           class="dialog-footer">
        <Button @click="showImportModalStatus = false">取 消</Button>
        <Button type="primary"
                @click="confirmImport()">确 定</Button>
      </div>
    </Modal>
  </div>
</template>
  
  <script>
import ImageUpload from "../common/thumb";
import uploadFile from "../common/fileimport";
export default {
  components: {
    ImageUpload,
    uploadFile
  },
  data () {
    const validateSelectCate = (rule, value, callback) => {
      if (this.danwei.ti_type === "") {
        callback(new Error("请选择题型"));
      } else {
        callback();
      }
    };
    return {
      cate_list: [],
      continue_show: true,
      continue_status: false,
      isEdit: 0, // 0新增 1编辑
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      title: "",
      showDrawer: false,
      listLoading: false,
      total: 0,
      ModelList: [],
      danwei: {
        id: '',
        question: '',
        ti_type: 1,
        sort: 0,
        options: [],
        point: '',
        origin: '',
        cate_id: '',
        is_right: ''
      },
      rules: {
        ti_type: [
          { required: true, validator: validateSelectCate, trigger: "change" }
        ],
        question: [{
          required: true,
          message: '请输入题目',
          trigger: 'blur'
        }],
      },

      listQuery: {
        key: '',
        page: 1,
        size: 10
      },
      tableData: [],
      column: [
        {
          title: "Id",
          key: "id",
          width: 80
        },
        {
          title: "题型",
          minWidth: 300,
          key: "ti_type_str",
        },
        {
          title: "题目",
          minWidth: 300,
          key: "question",
        },
        {
          title: "知识点",
          minWidth: 300,
          key: "point",
        },
        {
          title: "原文",
          minWidth: 300,
          key: "origin",
        },
        {
          title: "状态",
          key: "status",
          width: 100,
          render: (h, params) => {
            return h("div", [
              h(
                "i-switch",
                {
                  props: {
                    value: params.row.status //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    "on-change": value => {
                      this.changeStatus(params.row.id, value);
                    }
                  }
                },
                "开关"
              )
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          minWidth: 130,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEdit(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.removeType(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      ti_type_list: [{ id: 1, name: '单选题' }, { id: 2, name: '多选题' }, { id: 3, name: '判断题' }],
      showImportModalStatus: false,
      fileList: [],
      leadIn: {
        file_path: "",
        cate_id: ''
      },
      moduleid: 0,
    }
  },
  created () {
    this.moduleid = this.$route.params.id;
    this.getList()
  },
  methods: {
    handleFilter (name) {
      if (name != 1) {
        this.listQuery.page = 1;
      }
      this.getList();
    },
    changeStatus (row) {
      let params = {
        id: row.id,
        status: row.status,
      };
      this.listLoading = true;
      this.$api.tiku.status(params).then(res => {
        this.listLoading = false;
        if (res.code == 200) {
          this.getList(this.listQuery.page)
        }
      })
    },
    delBtnFun (index) {
      this.danwei.options.splice(index, 1);
    },
    addOption: function () {
      let opt = {
        content: '',
        is_right: 0,
      }
      this.danwei.options.push(opt);
    },
    downloadTpl: function () {
      window.location.href = "/template/题库导入模板.xlsx";
    },
    confirmImport (name) {
      if (this.$refs.uploadFile.resList.length > 0) {
        // 视频
        this.leadIn.file_path = this.$refs.uploadFile.resList[0].url;
      }
      this.$api.tiku.import({ file_path: this.leadIn.file_path, module_id: this.moduleid }).then(res => {
        if (res.code == 200) {
          this.showImportModalStatus = false;
          this.getList();
          if (res.result.import_status == 0) {
            this.$message.warning(res.msg);
            window.open(res.result.url)
          }
        }
      });
    },
    handleImport: function () {
      this.showImportModalStatus = true;
      if (this.$refs.uploadFile) {
        this.$refs.uploadFile.handleClearFiles();
      }
      this.fileList = [];
      this.leadIn.file_url = "";
    },
    /**
     * @name: 获取列表
     * @return {*}
     * @desc:
     */
    getList (val) {
      if (val && val.page) {
        this.listQuery.page = val.page
      }
      this.listLoading = true
      this.listQuery.module_id = this.moduleid;
      this.$api.tiku.list(this.listQuery).then(res => {
        this.listLoading = false
        if (res.code == 200) {
          this.tableData = res.result.list;
          this.listQuery.total = res.result.total;
        }
      })
    },
    changePage () {
      this.listQuery.page = this.$refs["listPage"].currentPage;
      this.handleFilter(1);
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    handleCreate () {
      const that = this
      this.isEdit = 0
      this.showDrawer = true
      this.continue_show = true;
      this.resetForm()
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    showEdit (index) {
      this.continue_show = false;
      const that = this
      this.isEdit = 1
      this.showDrawer = true
      this.resetForm()
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
      that.id = index
      this.$api.tiku.detail({
        id: that.id
      }).then(res => {
        if (res.code == 200) {
          this.danwei = res.result
        }
      })
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc:
     */
    tijiao (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.danwei.ti_type != 3 && this.danwei.options.length == 0) {
            this.$message.warning('选项不能为空')
            return
          }
          if (this.id) {
            // 编辑
            const params = this.danwei
            this.$api.tiku.edit(params).then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.closeDrawerFun()
                this.getList(this.listQuery.page)
              } else {
                this.resetForm()
              }
            })
          } else {
            this.danwei.module_id = this.moduleid;
            // 新增
            this.$api.tiku.create(this.danwei).then(res => {
              if (res.code === 200) {
                this.$Message.success(res.msg);
                if (this.continue_status) {
                  this.danwei = {
                    id: '',
                    question: '',
                    ti_type: 1,
                    sort: 0,
                    options: [],
                    point: '',
                    origin: '',
                    cate_id: ''
                  }
                } else {
                  this.closeDrawerFun()
                }
                this.getList()
              }
            })
          }
        } else {
          this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false
      this.resetForm()
    },
    /**
     * @name: 删除
     * @param {*} row
     * @return {*}
     * @desc:
     */
    delFun (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.tiku.remove({
          id: row
        }).then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.getList(this.listQuery.page)
          } else {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {
      })
    },
    /**
     * @name: 清空
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.id = null
      this.danwei = {
        id: '',
        question: '',
        ti_type: 1,
        sort: 0,
        options: [],
        point: '',
        origin: '',
        cate_id: '',
        is_right: ''
      }
    }

  }
}
  </script>
  <style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>
  